// ts-gql-integrity:44d40714678a178a70405b0bdffab37d
/*
ts-gql-meta-begin
{
  "hash": "1d847c897753b1b389db916061aad994"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type CreateUserMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.TenantUserCreateUpdateInput;
}>;


type CreateUserMutation = { readonly __typename: 'Mutation', readonly createUpdateTenantUser: { readonly __typename: 'TenantUserCreateUpdateResponse', readonly cloudId: string | null, readonly actionPerformed: boolean | null } | null };



export type type = TypedDocumentNode<{
  type: "mutation";
  result: CreateUserMutation;
  variables: CreateUserMutationVariables;
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    CreateUser: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"CreateUser\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"TenantUserCreateUpdateInput\"}}},\"directives\":[]}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"createUpdateTenantUser\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"inputUserData\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}}}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cloudId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"actionPerformed\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
